import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { landingRoutePaths } from './utils/landingRoutes';
import LandingPage from './Pages/LandingPage';
import UnderMaintenance from './Pages/UnderMaintenance';

// import './App.css';
import './CSS/Pages/LandingPage.css';

// https://stackoverflow.com/questions/36904185/react-router-scroll-to-top-on-

function App() {

  console.log("App component rendered");
  useEffect(() => {
    const editingSelector = "input, textarea, select, [contenteditable='true']";
    const keyboardHeightThreshold = 80;
    let viewportSettleTimeoutId = null;
    let keyboardSection = null;
    let keyboardBaselineHeight = null;
    let keyboardBaselineWidth = null;
    let isKeyboardTransitioning = false;

    const getViewportHeight = () => window.visualViewport?.height ?? window.innerHeight;

    const updateViewportHeight = (viewportHeight = getViewportHeight()) => {
      const vh = viewportHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    const startKeyboardTransition = (editingElement) => {
      if (!keyboardSection) {
        keyboardSection = editingElement.closest("#connect");
        keyboardBaselineHeight = getViewportHeight();
        keyboardBaselineWidth = window.innerWidth;
      }

      isKeyboardTransitioning = true;
      document.documentElement.classList.add("keyboard-transition-active");
    };

    const finishKeyboardTransition = () => {
      const viewportHeight = getViewportHeight();
      const didOrientationChange = keyboardBaselineWidth !== null &&
        Math.abs(window.innerWidth - keyboardBaselineWidth) > keyboardHeightThreshold;
      const isKeyboardStillOpen = !didOrientationChange && keyboardBaselineHeight !== null &&
        viewportHeight < keyboardBaselineHeight - keyboardHeightThreshold;

      if (isKeyboardStillOpen) {
        return;
      }

      isKeyboardTransitioning = false;
      updateViewportHeight(didOrientationChange ? viewportHeight : keyboardBaselineHeight ?? viewportHeight);
      keyboardSection?.scrollIntoView({ behavior: "auto", block: "start" });

      window.requestAnimationFrame(() => {
        keyboardSection = null;
        keyboardBaselineHeight = null;
        keyboardBaselineWidth = null;
        document.documentElement.classList.remove("keyboard-transition-active");
      });
    };

    const scheduleViewportSettle = () => {
      if (viewportSettleTimeoutId) {
        window.clearTimeout(viewportSettleTimeoutId);
      }

      viewportSettleTimeoutId = window.setTimeout(() => {
        viewportSettleTimeoutId = null;
        finishKeyboardTransition();
      }, 400);
    };

    const handleViewportResize = () => {
      const activeElement = document.activeElement;
      const isEditing = activeElement instanceof HTMLElement && activeElement.matches(editingSelector);
      const stableViewportHeight = parseFloat(
        document.documentElement.style.getPropertyValue("--vh")
      ) * 100;

      if (
        isEditing &&
        !isKeyboardTransitioning &&
        Number.isFinite(stableViewportHeight) &&
        getViewportHeight() < stableViewportHeight - keyboardHeightThreshold
      ) {
        keyboardSection = activeElement.closest("#connect");
        keyboardBaselineHeight = stableViewportHeight;
        keyboardBaselineWidth = window.innerWidth;
        isKeyboardTransitioning = true;
        document.documentElement.classList.add("keyboard-transition-active");
      }

      if (isKeyboardTransitioning) {
        scheduleViewportSettle();
        return;
      }

      updateViewportHeight();
    };

    const handleVisualViewportScroll = () => {
      if (isKeyboardTransitioning) {
        scheduleViewportSettle();
      }
    };

    const handleFocusIn = (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches(editingSelector)) {
        return;
      }

      startKeyboardTransition(event.target);
    };

    const handleFocusOut = (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches(editingSelector)) {
        return;
      }

      isKeyboardTransitioning = true;
      scheduleViewportSettle();
    };
    const visualViewport = window.visualViewport ?? null;
  
    // Call on load
    updateViewportHeight();
  
    // Update on resize
    window.addEventListener("resize", handleViewportResize);
    window.addEventListener("orientationchange", handleViewportResize);
    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);
    visualViewport?.addEventListener("resize", handleViewportResize);
    visualViewport?.addEventListener("scroll", handleVisualViewportScroll);
  
    // Cleanup event listener
    return () => {
      if (viewportSettleTimeoutId) {
        window.clearTimeout(viewportSettleTimeoutId);
      }

      document.documentElement.classList.remove("keyboard-transition-active");
      window.removeEventListener("resize", handleViewportResize);
      window.removeEventListener("orientationchange", handleViewportResize);
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
      visualViewport?.removeEventListener("resize", handleViewportResize);
      visualViewport?.removeEventListener("scroll", handleVisualViewportScroll);
    };
  }, []);
  
  return (
    <div className="App">
      <HelmetProvider>
        <Router>
          <Routes>
            {landingRoutePaths.map((path) => (
              <Route key={path} path={path} element={<LandingPage />} />
            ))}
            <Route path="/comingsoon" element={<UnderMaintenance />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </div>
  );
}

export default App;
